export default (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "SET_LOADING_OFF":
      return {
        ...state,
        loading: false,
      };
    case "SET_USER":
      localStorage.setItem('user', JSON.stringify({ ...state.user, ...action.payload }))
      return {
        ...state,
        user: { ...state.user, ...action.payload },
        loading: false,
      };
    case "SET_ORGANIZATION":
      localStorage.setItem('organization', JSON.stringify({ ...state.organization, ...action.payload }))
      return {
        ...state,
        organization: { ...state.organization, ...action.payload },
        loading: false,
      };
    case "SET_TEAMS":
      return {
        ...state,
        teams: action.payload,
        loading: false,
      };
    case "SET_TRANSACTIONSLIST":
      return {
        ...state,
        totalTransaction: action.payload,
        loading: false

      };
    case "SET_EMPLOYEES":
      return {
        ...state,
        employees: action.payload,
        loading: false,
      };
    case "ADD_EMPLOYEE":
      return {
        ...state,
        employees: [action.payload, ...state.employees],
        loading: false,
      };
    case "ADD_TEAM":
      return {
        ...state,
        teams: [action.payload, ...state.teams],
        loading: false,
      };
    case "UPDATE_TEAM":
      return {
        ...state,
        teams: [action.payload, ...state.teams.filter((team) => team.id !== action.payload.id),],
        /*{
                    budget: 556,
                    editing: false,
                    fundingStatus: "inactive",
                    id: "5f2d4889ca4dcb36e49dbefd",
                    location: "Remote",
                    name: "Accounts",
                    selected: false,
                    size: 0,
                    teamName: "Accounts",
                }*/
        loading: false,
      };
    case "DELETE_TEAM":
      return {
        ...state,
        teams: [...state.teams.filter((team) => team.id !== action.payload)],
        loading: false,
      };
    case "DELETE_PERKS_PROGRAM":
      return {
        ...state,
        perkPrograms: [...state.perkPrograms.filter((perkProgram) => perkProgram.id !== action.payload)],
        loading: false,
      };
    case "ADD_PERKS_PROGRAM":
      return {
        ...state,
        perkPrograms: [action.payload, ...state.perkPrograms],
        loading: false,
      };
    case "SET_CURRENT_PERK_PROGRAM":
      return {
        ...state,
        currentPerkProgram: action.payload,
        loading: false,
      };
    case "UPDATE_PERKS_PROGRAM":
      return {
        ...state,
        perkPrograms: [action.payload, ...state.perkPrograms.filter((program) => program.id !== action.payload.id)],
        loading: false,
      };
    case "SET_PERKS":
      return {
        ...state,
        perks: action.payload,
        loading: false,
      };
    case "SET_PERK_PROGRAMS":
      return {
        ...state,
        perkPrograms: action.payload,
        loading: false,
      };
    case "SET_EXPENSE_PROGRAMS":
      return {
        ...state,
        expensePrograms: action.payload,
        loading: false,
      };
    case "SET_EXPENSE_CATEGORIES":
      return {
        ...state,
        expenseCategories: action.payload,
        loading: false,
      };
    case "ADD_EXPENSE_PROGRAM":
      return {
        ...state,
        expensePrograms: [action.payload, ...state.expensePrograms],
        loading: false,
      };
    case "DELETE_EXPENSE_PROGRAM":
      return {
        ...state,
        expensePrograms: [...state.expensePrograms.filter((expenseProgram) => expenseProgram.id !== action.payload)],
        loading: false,
      };
    case "UPDATE_EXPENSE_PROGRAM":
      return {
        ...state,
        expensePrograms: [action.payload, ...state.expensePrograms.filter((program) => program.id !== action.payload.id)],
        loading: false,
      };
    case "USER_LOG_OUT":
      return {
        ...state,
        loading: false,
        user: {
          accessToken: "",
          email: "",
          firstName: "",
          lastName: "",
        },
        organization: {
          verified: false,
          legalEntityName: "",
          entityType: "",
          website: "",
          EIN: "",

          street: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          createdAt: "",
          updatedAt: "",
          primaryContact: {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            signatoryType: "",
            linkedInProfile: "",
          },
          secondaryContact: {
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            linkedInProfile: "",
          },
          peopleOpsContact: {
            firstName: "",
            lastName: "",
            phoneNumber: "",
            email: "",
          },
          perkBudgetApproverContact: {
            firstName: "",
            lastName: "",
            phoneNumber: "",
            email: "",
          },
        },
        teams: [],
        employees: [],
        perks: [],
        perkPrograms: [],
        currentPerkProgram: {},
      };
    default:
      return state;
  }
};
